import { useNavigate } from 'react-router-dom'
import { Alert, Button, Table } from 'reactstrap'
import SearchFormRow from './SearchFormRow'
import useSearchForm from './SearchFormHook'
import { SEARCH_OPERATOR, FIELD_TYPE } from '../../constants'
import { makeInteger, replaceUnicode, setSessionStorage } from '../../utils'
import './SearchForm.css'
import { initialFormValues } from '../CustomCode/CustomUtils'
import { useEffect, useRef, useState } from 'react'

export default function SearchForm({ search, location }) {
  console.log(`SearchForm rendered: ${search.id}`, location)

  const parameterSize = 2000

  const navigate = useNavigate()
  const [formFeedback, setFormFeedback] = useState()

  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  function submitSearch() {
    console.log('SearchForm.submitSearch', inputs)
    console.log(inputs, search)
    const newInputs = []
    let badParameters = ''
    let comma = ''
    for (let input of inputs) {
      if (input.inputValue.length > 0 || makeInteger(input.operator) === SEARCH_OPERATOR.isNull) {
        for (let i = 0; i < input.inputValue.length; i++) {
          input.inputValue[i] = input.inputValue[i].replace(/#/g, '%23')
          if (makeInteger(input.fieldType) === FIELD_TYPE.currency) {
            input.inputValue[i] = input.inputValue[i].replace(/,/g, '')
          }
        }
        newInputs.push(input)
      }
      if (JSON.stringify(input).length > parameterSize) {
        for (let detail of search.details) {
          if (detail.id === input.id) {
            badParameters += comma + detail.field.name
            comma = ', '
          }
        }
      }
    }

    if (badParameters) {
      return setFormFeedback(<tr ref={scrollRef}><td colSpan='100%'><Alert color='danger' style={{width: 'fit-content', textAlign: 'center', margin: 'auto', marginBottom: '5px'}}>The following search parameters have too many values: <b>{badParameters}</b></Alert></td></tr>)
    }

    const url = `/searchResults/${search.id}?inputs=${JSON.stringify(newInputs)}${location.search.replace('?', '&')}`
    setSessionStorage(`${search.id}`, JSON.stringify(inputs))
    navigate(url)
  }

  let initialValues = []
  search.details.forEach((detail) => {
    if (detail.prompt === 'Y') {
      const value = {
        id: detail.id,
        fieldType: detail.field.type.id,
        notOperator: 'N',
        operator: detail.fieldTypeOperators[0].id,
        inputValue: [],
      }
      initialValues.push(value)
    }
  })
  console.log('SearchForm initialValues: ', initialValues) 

  initialValues = initialFormValues(`${search.id}`, navigate, initialValues)
  const { inputs, handleInputChange, handleSubmit } = useSearchForm(initialValues, submitSearch)
  const rows = []
  let count = 0
  search.details.forEach((detail) => {
    if (detail.prompt === 'Y') {
      const row = <SearchFormRow key={detail.id} index={count} detail={detail} handleChange={handleInputChange} operatorId={inputs[count].operator} defaultValues={inputs[count]} />
      rows.push(row)
      count++
    }
  })
  return (
    <div className="search-form-container">
      <form onSubmit={handleSubmit}>
        <h3 className="search-form-title">{replaceUnicode(search.name)}</h3>
        <div>
          <Button color="primary" style={{ marginBottom: '5px' }} data-cy="search-form-search-button">Search</Button>
        </div>
        <div>
          <Table data-cy='search-form-table' className="search-form-table" borderless>
            <tbody>
              {formFeedback}
              {rows}
            </tbody>
          </Table>
        </div>
        <div>
          <Button color="primary" style={{ marginTop: '5px' }}>Search</Button>
        </div>
      </form>
    </div>
  )
}